import { FAQS } from "@/data/site";
import { LeadForm } from "@/components/LeadForm";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Seo } from "@/components/Seo";

export default function Faqs() {
  return (
    <div data-testid="faqs-page">
      <Seo title="AC Service FAQs & Pricing Answers | Central Air Depot" description="Straight answers on AC service costs, duct cleaning, maintenance plans, emergency booking and service areas in South Florida." />
      <section className="bg-brand-ink text-white">
        <div className="max-w-7xl mx-auto px-4 py-20 sm:py-28">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-ice mb-3">FAQs</p>
          <h1 className="text-4xl sm:text-5xl tracking-tighter leading-none font-black max-w-2xl">Questions, answered honestly</h1>
        </div>
      </section>
      <section className="bg-white">
        <div className="max-w-3xl mx-auto px-4 py-16 sm:py-24">
          <Accordion type="single" collapsible data-testid="faqs-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`}>
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-medium text-brand-ink">{f.q}</AccordionTrigger>
                <AccordionContent className="text-zinc-600 leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
      <section className="bg-brand-subtle">
        <div className="max-w-3xl mx-auto px-4 py-16 sm:py-24">
          <LeadForm heading="Still have a question?" subtext="Send it over — a specialist will get back to you fast." />
        </div>
      </section>
    </div>
  );
}
